/**
 * ErrorMessage - Reusable error message component
 *
 * Used for consistent error displays across pages
 */

interface ErrorMessageProps {
  message: string;
  className?: string;
}

export function ErrorMessage({ message, className = '' }: ErrorMessageProps) {
  return (
    <div
      className={`rounded-xl border border-red-200 dark:border-red-800 bg-red-50 dark:bg-red-900/20 p-6 ${className}`}
    >
      <p className="text-red-800 dark:text-red-200">{message}</p>
    </div>
  );
}
